import styled from 'styled-components';
import { GlobalToken } from 'antd';

import EPInput from '../../../../EPInput';
import { getTableCss } from '../Common/styled';

interface DefaultRuleContainerProps {
  $fromRulesEditor: boolean;
  $hasFinishedWizard: boolean;
  $isReadOnly?: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const DefaultRuleContainer = styled.div<DefaultRuleContainerProps>`
  display: flex;
  flex-direction: column;
  position: relative;

  background-color: ${({ theme: { token } }) => token.colorBgContainer};

  ${({ $isReadOnly }) => $isReadOnly && 'pointer-events:none;'}

  ${({ theme: { token } }) => getTableCss(token)}

  .label-text {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    color: ${({ theme: { token } }) => token.colorTextTertiary};
  }

  .no-value {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
  }

  .table {
    .ant-table {
      background-color: ${({ theme: { token } }) => token.colorBgContainer};
      .ant-table-thead > tr > th {
        background-color: ${({ theme: { token } }) => token.colorBgElevated};
      }
    }
    .ant-table .ant-table-tbody > tr > td.ant-table-cell {
      margin-left: ${({ theme: { token } }) => token.marginXS}px;
    }

    ${({ $fromRulesEditor }) =>
      $fromRulesEditor
        ? `
      .ant-table {
        background-color: ${({ theme: { token } }) => token.colorBgBase}; 

        .ant-table-cell-scrollbar {
          background-color: ${({ theme: { token } }) => token.colorBgElevated};
        }
      }

      

      .ant-table .ant-table-tbody > tr > td.ant-table-cell-row-hover {
        background: ${({ theme: { token } }) => token.colorBgBase};
      }

      .view-mode-table-cell {
        font-size: ${({ theme: { token } }) => token.fontSize}px;
                color: ${({ theme: { token } }) => token.colorBorder};
      }

      .margin-left-2 {
        margin-left: 2px;
      }

      .margin-left-4 {
        margin-left: ${({ theme: { token } }) => token.marginXXS}px;
      }

      .check-icon {
        width: 10px;
        color: ${({ theme: { token } }) => token.colorBorder};
      }
  
      
  `
        : `
        max-height: ${({ $hasFinishedWizard }) => ($hasFinishedWizard ? '509px' : '375px')}; 

        .ant-table-cell-scrollbar {
          background-color: ${({ theme: { token } }) => token.colorBgElevated};
        }

      

        .disabled-compressor {
          opacity: 0.4;
        }
    `}
  }

  .expand-data-container {
    display: flex;
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.padding}px`};
    justify-content: flex-end;
  }

  .compressor-header {
    padding-left: ${({ theme: { token } }) => token.paddingSM}px;
  }

  .modulate-header {
    padding-right: ${({ theme: { token } }) => token.padding}px;
  }

  .info-message {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextDisabled};
  }
`;

interface InputProps {
  $hasBeenEdited: boolean;
  $valueLength?: number;
  $fromRulesEditor?: boolean;
  $hasFinishedWizard?: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const Input = styled(EPInput)<InputProps>`
  width: 60px;

  &.ant-input {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    color: ${({ theme: { token } }) => token.colorPrimary};
    padding-left: ${({ theme: { token } }) => token.paddingXXS}px;
    padding-right: 0;
    height: 21px;
    ${({ value }) => (value || value === 0) && 'text-decoration: underline;'}
    ${({ $fromRulesEditor, $hasBeenEdited, $hasFinishedWizard, theme: { token } }) =>
      ($fromRulesEditor || $hasFinishedWizard) &&
      `
        background-color: ${$hasBeenEdited ? token.colorBgElevated : token.colorBgContainer};
        border: none;
      `}
      width: ${({ $valueLength }) => ($valueLength ? `calc(${$valueLength}ch + 1ch);` : '18px;')}

    &::placeholder {
      color: ${({ theme: { token } }) => token.colorPrimary};
    }
  }
`;
